module.exports = __webpack_public_path__ + "img/lunch.739c2fc0.jpg";